<app-map-content-selector class="content-selector-container" (click)="toggleMobileViewContext.emit()" [text]="text" [showIcon]="showIcon"></app-map-content-selector>
<ng-content></ng-content>
<div class="content-pane map-pane"
    [fxShow]="isMapShown">
    <ng-template appSharedMapSingleton></ng-template>
</div>
